import type { SupabaseClient } from "@supabase/supabase-js";

export type AuditAction =
  | "scan_completed"
  | "item_status_changed"
  | "item_deleted"
  | "item_restored"
  | "item_edited"
  | "plan_upgraded"
  | "inventory_cleared";

export async function insertAuditLog(
  client: SupabaseClient,
  userId: string,
  payload: {
    action: AuditAction | string;
    entityType?: string;
    entityId?: string | null;
    meta?: Record<string, unknown>;
  },
): Promise<void> {
  try {
    const { error } = await client.from("audit_logs").insert({
      user_id: userId,
      action: payload.action,
      entity_type: payload.entityType ?? "medication",
      entity_id: payload.entityId ?? null,
      meta: payload.meta ?? {},
    });
    if (error) console.warn("audit_logs insert:", error.message);
  } catch (e) {
    console.warn("audit_logs insert failed", e);
  }
}

export async function logFieldOverride(params: {
  supabase: SupabaseClient;
  medicationId: string;
  fieldName: string;
  aiValue: string | null;
  userValue: string;
  aiConfidence?: number;
  userId: string;
}): Promise<void> {
  try {
    await params.supabase.from("medication_field_overrides").insert({
      medication_id: params.medicationId,
      field_name: params.fieldName,
      ai_value: params.aiValue,
      user_value: params.userValue,
      ai_confidence: params.aiConfidence ?? null,
      changed_by: params.userId,
    });
  } catch {
    // Non-blocking audit path; editing should continue if this insert fails.
  }
}
